/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import CalAmpLogo from '@ion/dls/src/logo/CalAmpLogo';
import {dlsColor} from '@ion/dls/src/theme/theme';
import styles from './DesktopHeader.module.scss';

/**
 * The Desktop Header Logo component provides the application Header
 * Logo for the iOn Application when view in Desktop Mode.
 */
export const DesktopHeaderLogo = () => (
  <div className={styles.logo} style={{flexGrow: 1}}>
    <CalAmpLogo width={170} height={37} fill={dlsColor('caBlue')} />
  </div>
);

export default React.memo(DesktopHeaderLogo);
